import { useMemo } from 'preact/hooks';
import qrcode from 'qrcode-generator';

/**
 * Renders a QR code as a crisp SVG (no canvas, no network). Used for voucher
 * redemption — a partner scans this to redeem, same as the mobile app.
 */
export function QrCode({ value, size = 180 }: { value: string; size?: number }) {
  const path = useMemo(() => {
    const qr = qrcode(0, 'M');
    qr.addData(value);
    qr.make();
    const count = qr.getModuleCount();
    let d = '';
    for (let r = 0; r < count; r++) {
      for (let c = 0; c < count; c++) {
        if (qr.isDark(r, c)) d += `M${c} ${r}h1v1h-1z`;
      }
    }
    return { d, count };
  }, [value]);

  return (
    <svg
      class="bc-qr"
      width={size}
      height={size}
      viewBox={`0 0 ${path.count} ${path.count}`}
      shape-rendering="crispEdges"
      role="img"
      aria-label="QR code"
    >
      <rect width={path.count} height={path.count} fill="#ffffff" />
      <path d={path.d} fill="#0a0705" />
    </svg>
  );
}
